import {CONFIG} from '../config.js';
import { windowInfo } from './WindowInfo.js';
import './ResizeEnd.js';

class ViewportFit {
	#tag = $('meta[name=viewport]');

	constructor() {
		this.update()
		$(window).on('resizeEnd', () => {
			this.update();
		});
	}

	update() {
		this.#tag.attr('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0');
		const ww = (windowInfo.size.w < window.screen.width) ? windowInfo.size.w : window.screen.width;
		const ratio =  ww / CONFIG.siteWidth;
		if( ww < CONFIG.siteWidth && ww > CONFIG.breakpoint){
			this.#tag.attr('content', 'width=' + ww + ', initial-scale=' + ratio + ', minimum-scale=' + ratio);
		}
	}
}


declare global {
	interface Window {
		viewportFit: ViewportFit
	}
}

/**
サイトの幅以下&ブレイクポイント以上のタブレットとかで見たときにviewportをいじって横スクロールが出ないようにさせるやつ<br/>importするだけで使える
@name viewportFit

@example JS
```js
import '/assets/js/modules/ViewportFit.js';
```
*/
export const viewportFit = window.viewportFit = new ViewportFit();
